import type { AdminUser } from '../models/user.model';

export const mockUsers: AdminUser[] = [
  {
    UserId: 'u-1',
    FirstName: 'Alice',
    LastName: 'Anderson',
    Email: 'alice.anderson@example.com',
    Role: 'SUPER_ADMIN',
    Status: true,
  },
  {
    UserId: 'u-2',
    FirstName: 'Bob',
    LastName: 'Baker',
    Email: 'bob.baker@example.com',
    Role: 'NORMAL_ADMIN',
    Status: false,
  },
  {
    UserId: 'u-3',
    FirstName: 'Carol',
    LastName: 'Carter',
    Email: 'carol.carter@example.com',
    Role: 'NORMAL_USER',
    Status: true,
  },
  {
    UserId: 'u-4',
    FirstName: 'David',
    LastName: 'Davis',
    Email: 'david.davis@example.com',
    Role: 'NORMAL_USER',
    Status: true,
  },
  {
    UserId: 'u-5',
    FirstName: 'Eve',
    LastName: 'Evans',
    Email: 'eve.evans@example.com',
    Role: 'NORMAL_ADMIN',
    Status: true,
  },
  {
    UserId: 'u-6',
    FirstName: 'Frank',
    LastName: 'Franklin',
    Email: 'frank.franklin@example.com',
    Role: 'NORMAL_USER',
    Status: true,
  },
  {
    UserId: 'u-7',
    FirstName: 'Grace',
    LastName: 'Griffin',
    Email: 'grace.griffin@example.com',
    Role: 'NORMAL_USER',
    Status: false,
  },
  {
    UserId: 'u-8',
    FirstName: 'Henry',
    LastName: 'Hill',
    Email: 'henry.hill@example.com',
    Role: 'SUPER_ADMIN',
    Status: true,
  },
];

export const getUserById = (id: string) =>
  mockUsers.find(u => u.UserId === id) || null;
